import controller from '../../../cases/fill/fill.controller';
import template from '../../../cases/fill/fill.pug';

const ResponseComponent = {
  template,
  controller,
  bindings: {
    case: '<',
  },
};

export default ResponseComponent;



// WEBPACK FOOTER //
// ./client/app/public/case/response/response.component.js